import { useAuth0 } from '@auth0/auth0-react';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';

import { SideNav } from 'components/sidenav/SideNav';
import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { handleError } from 'services/Error';
import { useAppSelector } from 'store';

/**
 * Component to determine if a user is authenticated and
 * if they are allowed to visit the page they navigated to.
 *
 * If they are: they proceed to the page
 * If not: they are redirected to the login page.
 */
export const RequireAuth = () => {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    const location = useLocation();

    // Ensure permissions and profile are loaded
    const { permissions } = useAppSelector((state) => state.auth);
    useEffect(() => {
        if (isAuthenticated) {
            if (permissions.length === 0) {
                handleError('User is not configured for this application.');
            }
        }
    }, [isAuthenticated, permissions]);

    if (!isAuthenticated) {
        sessionStorage.setItem(LOGIN_REDIRECT_KEY, location.pathname);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        loginWithRedirect();
        return <BlankScreen />;
    }

    return (
        <SideNav>
            <Outlet />
        </SideNav>
    );
};
